import { apiFetch } from "~/lib/fetchClient";

const emailDomainsApi = {
  list: (options) => apiFetch.get("/email_domains", options),
  create: (domain, options) =>
    apiFetch.post("/email_domains", { ...options, json: { domain } }),
  verify: (id, options) => apiFetch.put(`/email_domains/${id}/verify`, options),
  async remove(id, options) {
    await apiFetch.delete(`/email_domains/${id}`, options);
    return true;
  },
  async refresh(id, options) {
    const domains = await emailDomainsApi.list(options);
    const domain = domains.find((item) => item.id === id);
    if (!domain) {
      throw new Error(
        "This sending domain is no longer available. Reopen the sending domains page.",
      );
    }
    return domain;
  },
};

export default emailDomainsApi;
